import { Outlet } from 'react-router-dom';
import { getRuntimeConfig } from '@/lib/runtimeConfig';

/**
 * The sign-in screen's own layout — **CHANGE-1**.
 *
 * Figure 7.3 draws `/login` inside the app shell, with the nine nav items
 * listed but dimmed. UDC asked for a sign-in screen independent of the
 * dashboard, and that is the right call for a reason worth writing down: a
 * nav that lists Reports, Health and Access to somebody who is not signed in
 * advertises a surface they cannot reach, and the dimming is the only thing
 * saying so. A visitor who has not authenticated has exactly one thing to do
 * here.
 *
 * It is logged as a deliberate departure from the figure rather than folded
 * in silently — the figures are the visual contract, and a departure nobody
 * recorded is a defect at acceptance.
 */
export function AuthLayout() {
  const config = getRuntimeConfig();

  return (
    // UDC's grey page, flat: the panel carries the identity, not the ground.
    <div className="flex min-h-screen flex-col bg-pv-canvas">
      <main className="flex flex-1 items-center justify-center px-5 py-10">
        <div className="w-full max-w-[960px]">
          <Outlet />
        </div>
      </main>

      <footer className="px-6 py-5 text-center text-dense text-pv-muted">
        {config.tenantName} · {config.facilityLongName}
      </footer>
    </div>
  );
}
